/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartItems',[
    'jquery',
    'lodash',
    './CartManager',
    './CartDeliveryOptions',
    'global/all',
    'modules/Delivery/DeliveryOptions',
    'modules/Product/ProductService',
    'modules/InStorePickup/InStorePickup'
], function ($, _, CartManager, CartDeliveryOptions, Roc, DeliveryOptions, ProductService, InStorePickup) {
    'use strict';

    var isLoggedIn;
    // Customization: If user is processing quoted order, we need to lock all the options that would allow modifying cart
    var isLocked;
    // Customization: Overriding prices by customer service rep
    var canModifyPricing;
    var signInUrl;
    var addressBookUrl;
    var currentCart;
    var countries;
    var isSalesRep = false;
    var specialItems = [];

    function getItemData(element, attr) {
        return $(element).parents('.itemWrapper').attr('data-' + attr);
    }

    /* Events */
    function removeItemEvt() {
        $(document).on('click', '.removeCartItem', function () {
            Roc.UI.confirm('Are you sure you want to remove this item?', $.proxy(function () {
                var itemId = getItemData(this, 'item-id');
                var dataProductId = getItemData(this, 'product-id');
                Roc.UI.block();
                CartManager.removeOrderItem(itemId, dataProductId);
            }, this));
        });
    };

    function saveItemEvt() {
        $(document).on('click', '.saveCartItem', function (e) {
            var itemId = getItemData(this, 'item-id');
            Roc.Core.lockButton(e.currentTarget);
            Roc.UI.block();
            CartManager.saveOrderItem(itemId);
        });
    };

    function confirmZeroPriceItemsInCart(callback) {
        callback();
    }

    function reload(order) {
        currentCart = order;

        var recipients = [];
        var totalCost = 0;
        var totalMargin = 0;
        var totalPrice = 0;
        if (order !== undefined && order !== null) {
            _.forEach(order.recipients,
                function (r) {
                    _.forEach(r.items,
                        function (item) {
                            var recipient = _.cloneDeep(r);
                            _.assign(item.deliveryOptions, {
                                'addressBookUrl': addressBookUrl,
                                'signInUrl': signInUrl
                            });
                            // Customization: Add products sfsNumber to view model
                            Roc.ProductHelper.setProductSFSNumber(item);
                            // Customization: Add products cost to view model
                            var csrCost = item.cost;
                            if (!item.cost && item.cost <= 0) {
                                item.cost = item.price;
                                var productCostAtts = item.product.customFields["cost"];
                                if (productCostAtts && _.some(productCostAtts)) {
                                    item.cost = _.first(productCostAtts).value;
                                }
                            }

                            item.isSalesRep = isSalesRep;
                            if (item.product.productPricing.customFields) {
                                if (item.product.productPricing.customFields["rebateDescription"]) {
                                    item.displayRebateDescription = true;
                                    item.rebateDescription = item.product.productPricing.customFields["rebateDescription"];
                                }
                                else {
                                    item.displayRebateDescription = false;
                                }
                                if (item.product.productPricing.customFields["rebateCost"] > 0) {
                                    item.displayRebateCost = true;
                                    item.rebateCost = item.product.productPricing.customFields["rebateCost"];
                                }
                                else {
                                    item.displayRebateCost = false;
                                    item.displayRebateDescription = false;
                                }

                                if (item.product.productPricing.unitOfMeasure && item.product.productPricing.unitOfMeasure.isBaseUnit === false && csrCost <= 0) {
                                    var cost = item.cost * item.product.productPricing.unitOfMeasure.quantityInBaseUnit;
                                    item.cost = cost;
                                }
                            }

                            //BEGIN CUSTOMIZATION : to display total cost and total margin for SRP users 

                            if (canModifyPricing) {
                                if (item.rebateCost > 0) {
                                    totalCost = totalCost + (item.rebateCost * item.quantity);
                                }
                                else {
                                    totalCost = totalCost + (item.cost * item.quantity);
                                }
                                totalPrice = totalPrice + (item.price * item.quantity);
                            }

                            //END CUSTOMIZATION
                            recipient.items = [item];
                            recipients.push(recipient);

                        });
                });
        }
        // Customization: If user is processing quoted order, we need to lock all the options that would allow modifying cart
        var isLocked = !!currentCart && !!currentCart.customFields && !!currentCart.customFields.quoteId;

        var viewModel = {
            'isLoggedIn': isLoggedIn,
            'isLocked': isLocked, // customization: quotes
            'canModifyPricing': canModifyPricing, // customization: edit pricing when impesonating
            'recipients': recipients,
            'displayShipAndPickup': false // customization: hide ship and pickup buttons for empty cart
        };

        for (var i = 0; i < viewModel.recipients.length; i++) {
            for (var j = 0; j < viewModel.recipients[i].items.length; j++) {
                // customization: hide ship and pickup buttons for empty cart
                viewModel.displayShipAndPickup = true;
                var deliveryOptions = viewModel.recipients[i].items[j].deliveryOptions;
                deliveryOptions.defaultCountryCode = window.RocConfig.defaultCountryCode;
                deliveryOptions.enableInternationalShipping = window.RocConfig.shipping.enableInternationalShipping;
                deliveryOptions.countries = countries;
                //BEGIN CUSTOMIZATION : to display selected uom label on cart page
                var unitsOfMeasure = viewModel.recipients[i].items[j].unitOfMeasureViewModel;
                if (unitsOfMeasure && unitsOfMeasure.customFields) {
                    unitsOfMeasure.quantityInBaseUnit = unitsOfMeasure.customFields["soldByQty"];
                }
                //END CUSTOMIZATION
                //BEGIN CUSTOMIZATION : to display total cost and total margin for SRP users 
                if (canModifyPricing) {
                    totalMargin = ((totalPrice - totalCost) / totalPrice) * 100;
                    viewModel.totalCost = totalCost;
                    viewModel.totalMargin = totalMargin;
                    viewModel.canModifyPricing = canModifyPricing;

                    if (viewModel.recipients[i].items[j].product.customFields["isSpecialItem"] && viewModel.recipients[i].items[j].product.customFields["isSpecialItem"][0]) {
                        var isSpecialItem = viewModel.recipients[i].items[j].product.customFields["isSpecialItem"][0].value;
                        viewModel.recipients[i].items[j].isSpecialItem = isSpecialItem;
                        if (isSpecialItem) {
                            var specialText = getSpecialText(viewModel.recipients[i].items[j].sku);
                            if (specialText) {
                                viewModel.recipients[i].items[j].specialText = specialText;
                            }
                        }
                        if (isSalesRep && isSpecialItem) {
                            viewModel.recipients[i].items[j].displayRepCost = true;
                        }
                        else {
                            viewModel.recipients[i].items[j].displayRepCost = false;
                        }
                    }
                    viewModel.recipients[i].items[j].isNoteItem = true;
                }
                //END CUSTOMIZATION

            }
        }
        //Customization to move delivery options selection on cart level
        CartDeliveryOptions.updateIsShipping(viewModel);
        //END Customization

        Roc.UI.renderFormTemplate('#cart-Tmp', viewModel, $('#cartItemsListing')).then(function () {
            Roc.UI.unblock();
        });
    };


    function getSpecialText(sku) {
        var specialText = "";
        if (specialItems && specialItems.length > 0) {
            _.forEach(specialItems,
                function (item) {
                    if (item.sku === sku) {
                        specialText = item.name;
                    }
                });
        }
        return specialText;
    }

    function getCart() {
        Roc.UI.block();
        CartManager.getCurrentCart();
    };

    function updateAfterItemChanged(response) {
        if (response && response.success === true) {
            var $qtyTextbox = $('#qtyTextBox' + response.orderItemId);
            var $productList = $qtyTextbox.closest('#cartItemsListing');
            var $hiddenElem = $qtyTextbox.closest('.itemWrapper');
            var itemsCount = $productList.find('.itemWrapper').length;

            if (itemsCount <= 1) {
                $hiddenElem = $productList;
            }

            $hiddenElem.slideUp();
            getCart();
        } else {
            Roc.UI.ajaxErrorPopup(response, 'An error occurred while trying to update the item in your cart.');
        }
    };

    function updateAfterItemUpdate(response) {
        if (response && response.success === false) {
            var errorMessage = 'An error occurred while trying to update the item in your cart.';
            if (response.details !== null && response.details.errors !== null && response.details.errors.length > 0) {
                errorMessage = '';
                for (var i = 0; i < response.details.errors.length; i++) {
                    errorMessage += response.details.errors[i].errorMessage + '\n';
                }
            }
            Roc.UI.displayErrorPopup(errorMessage, 'There seems to be a problem');
        } else if (response && response.exceptionMessage) {
            Roc.UI.displayErrorPopup('An error occurred while updating unit price. Please try again. If the issue persists, please contact customer service.');
        }

        getCart();
    };

    function deliveryOptionChanged(data) {
        Roc.UI.block();
        var deliveryOptions = DeliveryOptions.getProductDeliveryOptions(data.productId, data.orderItemId);
        CartManager.updateCartItemDelivery(data.orderItemId, deliveryOptions, null);
    }

    function setPickupLocationForCartItem(cartItemId, store) {
        var deliveryOptions = {
            'deliveryType': ' Pickup',
            'pickupLocationId': store.location.id
        };
        Roc.UI.block();
        CartManager.updateCartItemDelivery(cartItemId, deliveryOptions, null);
    }

    function findStoreEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="findAnotherStore"]')
            .on('click', '[data-roc-action="findAnotherStore"]', function () {
                var itemId = getItemData(this, 'item-id');
                var productId = getItemData(this, 'product-id');
                ProductService.getById(productId).then(function (product) {
                    InStorePickup.findPickupStore(product).then(function (store) {
                        setPickupLocationForCartItem(itemId, store);
                    });
                }, function () {
                    Roc.UI.displayErrorPopup('There was an error while trying to get product details.');
                });
            });
    }

    function specialItemEvt() {
        Roc.UI.siteBody
            .off('blur', '[data-roc-action="specialItem"]')
            .on('blur', '[data-roc-action="specialItem"]', function () {
                var specialItem = {};
                specialItem.sku = this.id;
                specialItem.name = this.value;
                specialItems.push(specialItem);
            });
    }

    function bindEvents() {
        removeItemEvt();
        saveItemEvt();
        findStoreEvt();
        specialItemEvt();
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_ITEM, updateAfterItemUpdate);
        Roc.EventManager.bind(Roc.Events.cart.REMOVE_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.SAVE_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.MOVE_SAVED_ITEM, updateAfterItemChanged);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, reload);
        // Delivery options events
        Roc.EventManager.bind(Roc.Events.delivery.ADDRESS_BOOK_SELECTED, deliveryOptionChanged);
        Roc.EventManager.bind(Roc.Events.delivery.DELIVERY_OPTION_CHANGED, deliveryOptionChanged);
        Roc.EventManager.bind(Roc.Events.delivery.RECIPIENT_DATA_PROVIDED, deliveryOptionChanged);
    };

    function init(options) {
        bindEvents();
        isLoggedIn = options.isLoggedIn;
        isLocked = options.isLocked; // Customization: passing information about locking cart (quotes)
        canModifyPricing = options.canModifyPricing; // Customization: allow CustomerService rep to modify cart item pricing
        signInUrl = options.signInUrl;
        addressBookUrl = options.addressBookUrl;
        isSalesRep = options.isSalesRep;
        Roc.EventManager.notify(Roc.Events.cart.PAGE_LOAD, currentCart, true);
        if (options.model !== null) {
            countries = options.model.countries;

            $('#spanCartTotal').text('Cart (' + options.model.itemsInCart + ')');
            // Display errors from API

            if (options.model.errors && options.model.errors.length > 0) {
                Roc.UI.ajaxErrorPopup(options.model);
            }
        }
        reload(options.model !== null ? options.model.orderCart : null);

        var cartMsgCookie = Roc.Core.readCookie('cart-msg');
        if (cartMsgCookie !== null) {
            if (Roc.Core.isJson(cartMsgCookie)) {
                Roc.UI.ajaxErrorPopup(JSON.parse(cartMsgCookie));
            } else {
                Roc.UI.ajaxErrorPopup((cartMsgCookie));
            }

            Roc.Core.eraseCookie('cart-msg');
        }

        //Customization to move delivery options on cart level
        CartDeliveryOptions.init();
        //END
    };

    var CartItems = {
        init: init,
        reload: reload,
        updateAfterItemChanged: updateAfterItemChanged,
        updateAfterItemUpdate: updateAfterItemUpdate,
        confirmZeroPriceItemsInCart: confirmZeroPriceItemsInCart
    };

    Roc.Logger.debug('CartItems.js Loaded:', CartItems);

    return CartItems;
});

